import { EventDescription, Pricings } from './types/event'

interface PricingsRequestParams {
  dateId: Ref<string | undefined>
  quantity: Ref<number>
  isPrivate: Ref<boolean | undefined>
}

export const useFetchPricings = (
  eventId: Ref<string>,
  {
    // params to override the default params
    dateId,
    quantity,
    isPrivate,
  }: PricingsRequestParams
) => {
  const config = useRuntimeConfig()
  const url = `v1/store/events/${eventId.value}/pricings`

  const body = {
    // don't send event_id (date id) for kit and special giftcard events
    ...(dateId.value && { event_id: dateId.value }),
    private: isPrivate.value,
    ticket_categories: [
      {
        category: 'ADULT', // fixed category for now
        amount: quantity.value,
      },
    ],
  }

  return $fetch<Pricings>(url, {
    baseURL: config.public.apiBaseURL,
    body,
    method: 'POST',
  })
}

export const useEventPricings = (
  event: Ref<EventDescription | undefined>,
  { dateId = ref(undefined), quantity, isPrivate }: PricingsRequestParams
) => {
  const pricings = ref<Record<string, Pricings>>({})
  const eventId = computed(() => eventGetters.getId(event.value))
  const loading = ref(true)
  const { pricingKey } = useEventPricingsGetters(pricings, {
    dateId,
    quantity,
    event,
  })

  const fetchPricings = async () => {
    loading.value = true

    try {
      const pricingsResponse = await useFetchPricings(eventId, {
        dateId,
        quantity,
        isPrivate,
      })

      loading.value = false

      if (!pricingsResponse) {
        throw new Error('No pricings response')
      }

      pricings.value[pricingKey.value] = pricingsResponse
    } catch (error) {
      loading.value = false
      console.error(error)
    }
  }

  return {
    pricings,
    fetchPricings,
    loading,
  }
}
